module.exports = __webpack_public_path__ + "static/media/tractor.e5f6701e.svg";